import { AxiosResponse } from 'axios';
import { FBaseService, ResponseEnvelope, ResponseEnvelopeCollection } from '@kasasa/fbase-components/lib'; 
import Location from './Location';

interface LocationFilter {
	includeDisabled?: number | null;
}

export default class LocationService extends FBaseService {
	findAll(clientId: string, params: LocationFilter): Promise<AxiosResponse<ResponseEnvelopeCollection<Location>>> {
		return this.apiClient.get(`/api/kcms-location/${clientId}/location`, { params: params });
	}
	find(clientId: string, id: string): Promise<AxiosResponse<ResponseEnvelope<Location>>> {
		return this.apiClient.get(`/api/kcms-location/${clientId}/location/${id}`);
	}
	create(clientId: string, loc: Location) {
		return this.apiClient.post(`/api/kcms-location/${clientId}/location`, loc);
	}
	update(clientId: string, loc: Location) {
		return this.apiClient.put(`/api/kcms-location/${clientId}/location/${loc.id}`, loc);
	}
	delete(clientId: string | number, id: string | number): Promise<AxiosResponse<ResponseEnvelope<unknown>>> {
		return this.apiClient.delete(`/api/kcms-location/${clientId}/location/${id}`);
	}
	findAllActiveLocations(clientId: string, siteId: string): Promise<AxiosResponse<ResponseEnvelopeCollection<Location>>> {
		return this.apiClient.get(`/api/kcms-location/${clientId}/site/${siteId}/location`);
	}
	updateActiveLocations(clientId: string, siteId: string, locations: Location[]) {
		return this.apiClient.put(`/api/kcms-location/${clientId}/site/${siteId}/location`, locations);
	}
	findAllBranchImages(clientId: string): Promise<AxiosResponse<ResponseEnvelopeCollection<string>>>  {
		return this.apiClient.get(`/api/kcms-location/${clientId}/image`);
	}
}

export {
	LocationFilter
}